import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { changeDataCompanyInfo } from '../../../companyAnalysis/common/header/companyInfo/store/slice'
import EventEmitter, {
  SHOW_POPUP_FOLLOW_ALERT,
  SHOW_TOAST_MESSAGE,
} from '../../../helpers/EventEmitter'
import { UseI18n } from '../../hooks/useI18n'
import useViewport from '../../hooks/useViewport'
import { Element } from '../../html/element'
import { Loading } from '../../loading'
import { PopupAction } from '../PopupAction'
import { AlertForCompany } from './AlertForCompany'
import { AlertFromPortfolios } from './AlertFromPortfolios'
import { PortfolioList } from './PortfolioList'
import { ALERT_STATUS_ID } from './constant'
import './i18n'
import classes from './index.module.scss'
import {
  resetStore,
  selectLoading,
  selectOriginSettings,
  selectSettings,
} from './store/slice'
import { getFollowSettings, saveFollowSettings } from './store/thunk'

export const PopupFollowAlert = () => {
  const dispatch = useDispatch()
  const { height } = useViewport()

  const [searchParams] = useSearchParams()
  const organizationId = Number(searchParams.get('organizationId'))
  const originSettings = useSelector(selectOriginSettings)
  const settings = useSelector(selectSettings())
  const isLoading = useSelector(selectLoading('settings'))
  const isLoadingSave = useSelector(selectLoading('saveSettings'))

  const successMessage = UseI18n('common.SUCCESSFULLY_APPLIED')

  const [isShow, setIsShow] = useState(false)
  const [isShowPopupCancel, setIsShowPopupCancel] = useState(false)

  const isChange = JSON.stringify(originSettings) !== JSON.stringify(settings)

  const handleClose = () => {
    if (isChange) {
      setIsShowPopupCancel(true)
    } else {
      setIsShow(false)
    }
  }

  const handleApply = () => {
    if (!isChange) {
      setIsShow(false)
      return
    }

    const portfolios = (settings?.portfolios || []).filter(
      (item) => item.alertStatusId === ALERT_STATUS_ID.ON,
    )

    dispatch(
      saveFollowSettings({
        alertFollowSettingSave: { ...settings, portfolios, organizationId },
      }),
    )
      .unwrap()
      .then(() => {
        const isFollowed =
          settings?.hasProfileFollowingList ||
          settings?.portfolios?.some(
            (item) => item.alertStatusId === ALERT_STATUS_ID.ON,
          )
        dispatch(changeDataCompanyInfo({ isFollowed }))
        setIsShow(false)
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: successMessage,
        })
      })
  }

  useEffect(() => {
    if (isShow) {
      dispatch(getFollowSettings({ organizationId }))
    } else {
      dispatch(resetStore())
    }
  }, [isShow])

  useEffect(() => {
    EventEmitter.subscribe(SHOW_POPUP_FOLLOW_ALERT, setIsShow)
    return () => {
      EventEmitter.unsubscribe(SHOW_POPUP_FOLLOW_ALERT, setIsShow)
    }
  }, [])

  return (
    <>
      <PopupAction
        appendStyle={{
          backgroundColor: '#F3F3F3',
          borderRadius: 4,
          width: 850,
          padding: 20,
          maxHeight: height * 0.95,
        }}
        isShow={isShow}
        title={'common.popup.followAlert.TITLE'}
        handleClose={handleClose}
        btnCancel={{
          label: 'common.CLOSE',
          isI18n: true,
          event: handleClose,
        }}
        btnSubmit={{
          label: 'common.APPLY',
          isI18n: true,
          event: handleApply,
          disabled: isLoading || isLoadingSave,
        }}
      >
        {isLoading && <Loading />}
        <div style={{ opacity: isLoading ? 0 : 1 }}>
          <Element
            className={classes.box}
            style={{ backgroundColor: '#FFFFFF' }}
          >
            <AlertForCompany />
          </Element>

          <Element
            className={classes.box}
            style={{ backgroundColor: '#FFFFFF', marginTop: 12 }}
          >
            <AlertFromPortfolios />
            <PortfolioList />
          </Element>
        </div>
      </PopupAction>

      <PopupAction
        isShow={isShowPopupCancel}
        title={'common.CONFIRMATION'}
        handleClose={() => setIsShowPopupCancel(false)}
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: () => setIsShowPopupCancel(false),
        }}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: () => {
            setIsShowPopupCancel(false)
            setIsShow(false)
          },
        }}
      >
        <Translate value="common.popup.followAlert.CONFIRM_CANCEL" />
      </PopupAction>
    </>
  )
}
